import React, {FC} from 'react';
import css from "./SpecialityCard.module.scss"
import {Link} from "react-router-dom";
import {RouterNames} from "../../../../../../shared/enums/RouterNames";
import TitleWithLine from "../../../../../../shared/ui/TitleWithLine/TitleWithLine";
import {Speciality} from "../../../../../../entities/speciality";
import {ImageComponent} from "../../../../../../features/ImageComponent";


interface SpecialityCardProps {
    speciality: Speciality
}

const SpecialityCard: FC<SpecialityCardProps> = ({speciality}) => {
    return (
        <Link className={css.card} to={RouterNames.SPECIALITIES.to + `${speciality.id}`}>
            <ImageComponent className={css.cardImg} imgId={speciality.titleImage.id}/>
            <TitleWithLine title={speciality.title}/>
            <p className={css.cardDescription}>{speciality.description}</p>
            <div className={css.detailsContainer}>
                <span className={css.details}>Детальніше</span>
            </div>
        </Link>
    );
};

export default SpecialityCard;